<template>
  <div id="delete-confirmation-dialog">
    <v-dialog v-model="deleteDialog" width="600">
      <v-card>
        <v-card-title>削除確認</v-card-title>
        <v-card-text class="text-lg-body-1">削除を実行しますか？</v-card-text>
        <v-card-actions class="px-5 pb-5">
          <v-btn color="primary" @click="deleteDialog = false" width="100"
            >キャンセル</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="error" @click="deleteData()" width="100">削除</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { Component, Vue, PropSync, Emit } from "vue-property-decorator";

@Component
export default class DeleteConfirmationDialog extends Vue {
  /** ダイアログ表示フラグ */
  @PropSync("confirmationDialogFlag", { type: Boolean, default: false })
  deleteDialog!: boolean;

  /**
   * 削除実行時の処理
   * ※処理は親コンポーネントの関数で行う。
   */
  @Emit("deleteData")
  deleteData(): void {
    this.deleteDialog = false;
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/common.scss";
</style>
